import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IAttachment } from 'app/request-form/_models/attachment.interface';

@Component({
  selector: 'app-document-history',
  templateUrl: './document-history.component.html',
  styleUrls: ['./document-history.component.scss'],
  standalone: false,
})
export class DocumentHistoryComponent implements OnInit {
  @Input() attachments: IAttachment[];
  @Input() defaultQuantity = 4;
  @Output() clickItem = new EventEmitter<IAttachment>();

  showAllDocuments = false;
  quantityItems: number;

  ngOnInit() {
    this.quantityItems = this.defaultQuantity;
  }

  /**
   * Method called when attachment is clicked to download
   * @param attachment attachment clicked from attachment list
   */
  clickAttachment(attachment: IAttachment): void {
    this.clickItem.emit(attachment);
  }

  /**
   * Change the variable that defines whether to show all documents
   */
  toggleShowAllDocuments(): void {
    this.showAllDocuments = !this.showAllDocuments;
    this.setQuantityItems();
  }

  /**
   * Change the value of the variable that defines how many documents will be displayed
   */
  private setQuantityItems(): void {
    if (this.showAllDocuments) {
      this.quantityItems = this.attachments.length;
    } else {
      this.quantityItems = this.defaultQuantity;
    }
  }
}
